<template>
	<div class="bg-light">
		<div class="bg1">
			<img src="../assets/banner.png" alt="" class="banner" />
			<div class="text-pos wid">
				<div class="container3 text wid">
					<div class="first">因为胜任 所以信任</div>
					<div class="senced">because do so trust</div>
				</div>
			</div>
		</div>
		<div class="containers">
			<div class="title">
				<img src="~@imgs/productTitle.png" alt="" />
			</div>
			<div class="tabs">
				<div class="tab_item" v-for="item in tabList" :key="item.type"
					:class="{'active' : item.type === rightIndex}" @click="rightTap(item.type)">{{item.name}}</div>
			</div>
			<div class="titleList">
				<div class="titleItem" v-for="item in titleList" :key="item.id">
					<img :src="item.img" alt="" />
					<p style="font-size: 22px;color: #333232;">{{ item.name }}</p>
				</div>
			</div>
			<img src="~@imgs/ckgdbg.png" width="100px" height="20px" alt="" style="margin-top:45px"
				@click="goRouter('/productcenter')">
		</div>
		<div class="container1">
			<div class="title">
				<img src="~@imgs/gsjj.png" alt="" />
			</div>

			<div class="content">
				<p>富宁县药之家药店成立于2019年，注册资本 20万元，药之家药店是一家专业致力于药品零售的当地知名企业。</p>
				<p>成立至今，公司秉承“务实创新、努力拼搏、永不言败”的企业精神，以不断“为客户创造价值，为员工创造前景，为社会创造效益，为股东创造回报”作为公司的使命。</p>
				<p>企业精神：务实创新	  努力拼搏	   永不言败	</p>
			</div>
			<img src="~@imgs/ckgdbg.png" width="100px" height="20px" alt="" style="margin-top:45px;margin-bottom: 45px;"
				@click="goRouter('/companyprofile')">
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				rightIndex: 0,
				tabList: [{
						name: '药品',
						type: 0
					},
					{
						name: '医疗器械',
						type: 1
					}
				],
				titleList: [{
						id: 1,
						img: require("@imgs/1.jpg"),
						name: '盐酸苯环壬酯片（飞赛乐）',

					},
					{
						id: 2,
						img: require("@imgs/3.jpg"),
						name: '西地碘含片(华素片)',

					},
					{
						id: 3,
						img: require("@imgs/11.jpg"),
						name: '复方岩白菜素片',

					},
					{
						id: 4,
						img: require("@imgs/22.jpg"),
						name: '酚氨咖敏颗粒（克感敏颗粒）',
					},
				]
			};
		},
		methods: {
			rightTap(e) {
				this.rightIndex = e
				if (e == 0) {
					this.titleList = [{
							id: 1,
							img: require("@imgs/1.jpg"),
							name: '盐酸苯环壬酯片（飞赛乐）',
						},
						{
							id: 2,
							img: require("@imgs/3.jpg"),
							name: '西地碘含片(华素片)',
						},
						{
							id: 3,
							img: require("@imgs/11.jpg"),
							name: '复方岩白菜素片',
						},
						{
							id: 4,
							img: require("@imgs/22.jpg"),
							name: '酚氨咖敏颗粒（克感敏颗粒）',
						},
					]
				} else if (e == 1) {
					this.titleList = [{
							id: 1,
							img: require("@imgs/01.jpg"),
							name: '一次性使用气流雾化器',
						},
						{
							id: 2,
							img: require("@imgs/02.jpg"),
							name: '一次性使用输液器 带针',
						},
						{
							id: 3,
							img: require("@imgs/03.jpg"),
							name: '医用雾化器',
						},
						{
							id: 4,
							img: require("@imgs/04.jpg"),
							name: '一次性使用鼻氧管（双鼻式）',
						},
					]
				}
			},
			goRouter(value) {
				this.$router.push(value)
			},
			toDetail(item) {
				this.$router.push({
					path: '/goodDetail?id=' + item.id
				})
			}
		}
	};
</script>










<style lang="scss" scoped>
	.containers {
		margin-top: 75px;

		.title {
			margin: 20px 0 60px 0;
		}

		.tabs {
			width: 400px;
			height: 60px;
			margin: auto;
			display: flex;

			.tab_item {
				flex: 1;
				margin: 0px 10px;

				cursor: pointer;
				text-align: center;
				line-height: 60px;
				font-size: 24px;
			}

			.active {
				background-color: #17a2b8;
				color: #ffffff;
			}
		}

		.titleList {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 40px;

			.titleItem {
				width: 269px;
				height: 353px;
				background: #ffffff;
				border: 1px solid #cccccc;
				margin: 0 20px;
				padding-top: 30px;
				box-sizing: border-box;

				img {
					width: 100%;
					height: 220px;
				}
			}
		}
	}

	.container1 {
		width: 100%;
		// height: 700px;
		background: #f3f3f3;
		display: flex;
		flex-direction: column;
		// justify-content: center;
		align-items: center;
		margin-top: 48px;

		.title {
			margin-top: 75px;
		}

		.content {
			width: 1198px;
			font-size: 18px;
			font-family: Microsoft YaHei;
			color: #666666;
			margin-top: 60px;
			text-align: left;
		}
	}

	.container3 {
		margin: auto;
		padding: 0 15px;
	}

	.container2 {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 45px 0;

		.title {
			// margin-top: 30px;
		}

		.news {
			width: 100%;
			display: flex;
			justify-content: center;
			font-family: Microsoft YaHei;

			.newsItem {
				width: 561px;
				text-align: left;
				font-size: 18px;
				color: #666565;
				line-height: 30px;
				margin: 30px;

				.newstitle {
					font-size: 22px;
					font-weight: 400;
					color: #333232;
					line-height: 30px;
				}
			}
		}
	}

	.banner {
		width: 100%;
		height: 633px;
		margin-bottom: 7px;
	}

	.bg1 {
		position: relative;
	}

	.text-pos {
		position: absolute;
		top: 23%;
		left: 70%;
		color: brown !important;
		display: flex;
		justify-content: flex-start;
	}

	.text {
		text-align: left;
	}

	.first {
		font-size: 50px;
		font-family: Alegreya Sans SC ExtraBold;
		color: #f37c06;
		animation: myfirst 1.5s linear;
	}

	.senced {
		font-size: 50px;
		font-family: Alegreya Sans SC ExtraBold;
		color: #f37c06;
		animation: mysenced 1.5s linear;
	}

	.text-info {
		font-size: 32px;
		color: #17a2b8;
	}

	.center {
		text-align: center;
	}

	.m-bottom {
		margin-bottom: 21px;
	}

	.con-info {
		line-height: 2;
		text-align: left;
		font-size: 14px;
		text-indent: 28px;
	}

	@keyframes myfirst {
		0% {
			transform: translateY(-20px);
		}

		100% {
			transform: translateY(0px);
		}
	}

	@keyframes mysenced {
		0% {
			transform: translateY(-63px);
			opacity: 0;
		}

		80% {
			opacity: 0.5;
		}

		100% {
			transform: translateY(0px);
			opacity: 1;
		}
	}
</style>
